import script from "./GradeHorariaProfessor.vue?vue&type=script&setup=true&lang=js"
export * from "./GradeHorariaProfessor.vue?vue&type=script&setup=true&lang=js"

import "./GradeHorariaProfessor.vue?vue&type=style&index=0&id=4dbb8658&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dbb8658"]])

export default __exports__